import React, { useState, useEffect } from 'react';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import Tabs from '@mui/material/Tabs';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { DataGrid } from '@mui/x-data-grid';

import { DoModal, ModalContent } from "../../utils/Modal";
import { Height, Margin, Padding } from '@mui/icons-material';
import UserConfigMan from './UserConfigMan';
import './UsersAndRoles.css';

import { useAuth } from "../../hooks/AuthProvider";
import { getHeaders } from '../../utils/apis';
import AddModUserConfig from './AddModUserConfig';

export default function UserAndConfig() {

    const [userConfData, setUserConfData] = useState({});
    const childRef = useRef();

    const selectConfig = (data, next) => {

        setUserConfData({ ...data });
        childRef.current?.callReloadData(data['client_id']);


    }

    return (
        <div style={{ margin: "30px" }}>
            {<UserConfigMan selectConfig={selectConfig} />}
            <hr></hr>
            <AddModUserConfig userConfData={userConfData} />
        </div >
    );
}